module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../plugins/gatsby-local-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-TRP6ST7","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}},"routeChangeEventName":"gatsby-route-change"},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-contentful/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-core/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-core/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-login/gatsby-browser.js'),
      options: {"plugins":[],"basePath":"/login","isTheme":true},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-order-tracking/gatsby-browser.js'),
      options: {"plugins":[],"basePath":"/seguimiento-de-pedido","isTheme":true},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-magento/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-tmf/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-browse/gatsby-browser.js'),
      options: {"plugins":[],"basePath":"/browse","isTheme":true},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-cart/gatsby-browser.js'),
      options: {"plugins":[],"basePath":"/cart","isTheme":true},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-checkout/gatsby-browser.js'),
      options: {"plugins":[],"basePath":"/checkout","isTheme":true},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-smartphones/gatsby-browser.js'),
      options: {"plugins":[],"basePath":"/equipos","isTheme":true},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-plans/gatsby-browser.js'),
      options: {"plugins":[],"basePath":"/planes","isTheme":true},
    },{
      plugin: require('../node_modules/@womcorp/gatsby-theme-wom-accessories/gatsby-browser.js'),
      options: {"plugins":[],"basePath":"/accesorios","isTheme":true},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"wom","short_name":"wom","start_url":"/","background_color":"white","theme_color":"white","display":"standalone","cache_busting_mode":"none","icons":[{"src":"logowom.png","sizes":"48x48","type":"image/png"},{"src":"logowom.png","sizes":"72x72","type":"image/png"},{"src":"logowom.png","sizes":"96x96","type":"image/png"},{"src":"logowom.png","sizes":"144x144","type":"image/png"},{"src":"logowom.png","sizes":"192x192","type":"image/png"},{"src":"logowom.png","sizes":"211x211","type":"image/png"},{"src":"favicon_miwom.ico","sizes":"256x256","type":"image/png"},{"src":"logowom.png","sizes":"384x384","type":"image/png"},{"src":"logowom.png","sizes":"512x512","type":"image/png"}],"legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
